(() => {
  if (window.__pdlNewProductBadgeLoaded) return;
  window.__pdlNewProductBadgeLoaded = true;

  const MAX_AGE_SECONDS = 7 * 24 * 60 * 60;
  const CARD_SELECTOR = 'product-card.product-card, article.pdl-carousel-card';
  const timestampCache = new Map();
  let scanTimer = 0;

  function currentPreviewThemeId() {
    return new URL(window.location.href).searchParams.get('preview_theme_id') || '';
  }

  function parseThemeJSON(text) {
    const start = text.indexOf('{');
    const end = text.lastIndexOf('}');

    if (start === -1 || end === -1 || end < start) return null;

    try {
      return JSON.parse(text.slice(start, end + 1));
    } catch (error) {
      return null;
    }
  }

  function productPathFromCard(card) {
    const link = card.querySelector(
      'a.product-card__link[href*="/products/"], a.pdl-carousel-card__image[href*="/products/"], a[href*="/products/"]'
    );

    if (!link) return '';

    try {
      const url = new URL(link.href, window.location.origin);
      return url.pathname.replace(/\/$/, '');
    } catch (error) {
      return '';
    }
  }

  async function fetchCreatedAt(productPath) {
    if (!productPath) return 0;
    if (timestampCache.has(productPath)) return timestampCache.get(productPath);

    const request = (async () => {
      try {
        const url = new URL(productPath, window.location.origin);
        url.searchParams.set('view', 'pdl-logical-data');

        const previewThemeId = currentPreviewThemeId();
        if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);

        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json, text/plain, */*' },
        });

        if (response.ok) {
          const data = parseThemeJSON(await response.text());
          const timestamp = Number(data?.created_at || 0);
          if (Number.isFinite(timestamp) && timestamp > 0) return timestamp;
        }
      } catch (error) {
        // A falha deste recurso visual nunca deve interromper os cards.
      }

      try {
        const fallbackUrl = new URL(`${productPath}.js`, window.location.origin);
        const previewThemeId = currentPreviewThemeId();
        if (previewThemeId) fallbackUrl.searchParams.set('preview_theme_id', previewThemeId);

        const response = await fetch(fallbackUrl.toString(), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) return 0;

        const product = await response.json();
        const publishedAt = Date.parse(product.published_at || '');
        return Number.isFinite(publishedAt) ? Math.floor(publishedAt / 1000) : 0;
      } catch (error) {
        return 0;
      }
    })();

    timestampCache.set(productPath, request);
    return request;
  }

  function isNewProduct(createdAt) {
    const timestamp = Number(createdAt);
    if (!Number.isFinite(timestamp) || timestamp <= 0) return false;

    const ageSeconds = Math.floor(Date.now() / 1000) - timestamp;
    return ageSeconds >= 0 && ageSeconds < MAX_AGE_SECONDS;
  }

  function createBadge() {
    const badge = document.createElement('span');
    badge.className = 'pdl-new-product-badge';
    badge.textContent = 'Novo';
    badge.setAttribute('aria-label', 'Produto novo');
    return badge;
  }

  function insertBadge(card) {
    if (card.querySelector('.pdl-new-product-badge')) return;

    const nativeBadgeStack = card.querySelector('.product-badges');
    const badge = createBadge();

    if (nativeBadgeStack) {
      badge.classList.add('pdl-new-product-badge--stacked');
      nativeBadgeStack.append(badge);
      return;
    }

    const media = card.querySelector(
      '.pk-variant-grid-image, .pdl-carousel-card__image, .card-gallery, .product-card__media, .product-card-gallery, .product-card__image-wrapper'
    );

    if (!media) return;

    badge.classList.add('pdl-new-product-badge--overlay');
    media.append(badge);
  }

  async function processCard(card) {
    if (!(card instanceof HTMLElement)) return;
    if (card.dataset.pdlNewBadgeChecked === 'true') return;

    const productPath = productPathFromCard(card);
    if (!productPath) return;

    card.dataset.pdlNewBadgeChecked = 'true';
    const createdAt = await fetchCreatedAt(productPath);

    if (isNewProduct(createdAt) && card.isConnected) insertBadge(card);
  }

  async function scanCards(root = document) {
    const cards = [];

    if (root instanceof Element && root.matches(CARD_SELECTOR)) cards.push(root);
    cards.push(...root.querySelectorAll(CARD_SELECTOR));

    await Promise.all(cards.map(processCard));
  }

  function scheduleScan(root = document) {
    window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(() => scanCards(root), 80);
  }

  function start() {
    scheduleScan(document);

    const observer = new MutationObserver((mutations) => {
      const hasAddedNodes = mutations.some((mutation) => mutation.addedNodes.length > 0);
      if (hasAddedNodes) scheduleScan(document);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', (event) => scheduleScan(event.target));
    document.addEventListener('pdl:logical-cards-ready', () => scheduleScan(document));
    window.addEventListener('pageshow', () => scheduleScan(document));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
